import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  Signal,
  SimpleChanges,
  ViewChildren,
  computed,
  effect,
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  faCalendar,
  faSearch,
  faPlus,
  faEye,
  faTrash,
  faPen,
} from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContractForAdd } from 'src/app/core/models/ContractForAdd';
import { InstallmentIncreseForAdd } from 'src/app/core/models/InstallmentIncreseForAdd';
import { DateService } from 'src/app/services/date.service';
import { InstallmentTypeEnum } from 'src/app/core/models/InstallmentTypeEnum.enum';
import {
  ConfirmDialogSettings,
  ConfirmDialogComponent,
} from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { ContractEditService } from 'src/app/modules/contracts/pages/contract-edit/contract-edit.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { Contract } from 'src/app/core/models/Contract';
import { interval } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-contract-installment-setup',
  templateUrl: './contract-installment-setup.component.html',
  styleUrls: ['./contract-installment-setup.component.css'],
})
export class ContractInstallmentSetupComponent implements OnInit {
  iconCalendar = faCalendar;
  iconSearch = faSearch;
  iconPlus = faPlus;
  iconSee = faEye;
  iconTrash = faTrash;
  iconEdit = faPen;

  schemeType: number;
  isChecked: boolean = true;
  currencyTypeGuaranteeDeposit: number;
  guaranteeDepositCurrencyValue: number;
  adminAmountCurrencyType: number;
  adminAmountCurrencyValue: number;
  adminAmountPercentageValue: number;
  edit: boolean = false;
  editData: any;
  punitives: number;
  paymentExpiryDay: number;
  contractCurrency: number;
  confirmDeleteBoxTitles: ConfirmDialogSettings;

  invalidSchema: boolean;
  schemeTypeEnum = InstallmentTypeEnum;

  @Input() contractInput: ContractForAdd;
  @Input() createInMemory?: boolean = true;

  contractForEdit = toSignal(
    this.contractEditService.contractForEditObservable,
  );

  amountOfNewPeriods: number = 0;
    @Output() dataChanged = new EventEmitter<any>();
    @Output() dateChangeDetected = new EventEmitter<boolean>();

  private previousFromDate: Date;
  private previousToDate: Date;
  private hasFormData: boolean = false;
  @ViewChildren('checkedForErrors') viewChildren!: QueryList<ElementRef>;
  @ViewChildren(ConfirmDialogComponent)
  confirmBox: QueryList<ConfirmDialogComponent>;

  contractAmountFormGroup = new UntypedFormGroup({
    schemeType: new UntypedFormControl('', Validators.required),
    contractCurrency: new UntypedFormControl('', Validators.required),
    increaseType: new UntypedFormControl(''),
    currencyTypeGuaranteeDeposit: new UntypedFormControl(
      '',
      Validators.required,
    ),
    guaranteeDepositCurrencyValue: new UntypedFormControl('', [
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]),
    adminAmountCurrencyValue: new UntypedFormControl('', [
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]),
    adminAmountPercentageValue: new UntypedFormControl('', [
      Validators.min(0),
      Validators.max(100),
      Validators.required,
    ]),
    adminAmountCurrencyType: new UntypedFormControl('', Validators.required),
    paymentExpiryDay: new UntypedFormControl('', [
      Validators.min(1),
      Validators.max(31),
      Validators.required,
    ]),
    punitives: new UntypedFormControl('', [
      Validators.min(0),
      Validators.max(100),
      Validators.required,
    ]),

    /* Contract schema */
    installmentSchemas: new UntypedFormControl('', Validators.required),
    schemaAmount: new UntypedFormControl('', [
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]),
    secondSchemaAmount: new UntypedFormControl('', [
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]),
    thirdSchemaAmount: new UntypedFormControl('', [
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]),
    fourthSchemaAmount: new UntypedFormControl('', [
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]),
    fifthSchemaAmount: new UntypedFormControl('', [
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]),
    sixthSchemaAmount: new UntypedFormControl('', [
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]),
  });
  private lastValidationState: boolean = false;
  constructor(
    private modalService: NgbModal,
    private toastService: ToastService,
    public dateService: DateService,
    private contractEditService: ContractEditService,
  ) {
    this.confirmDeleteBoxTitles = {
      title: 'Desea Cambiar de Esquema?',
      subtitle: 'Los montos cargados seran borrados',
    };
  }

  ngOnInit() {
    const contract = this.contractInput as any;
    var fromDate = new Date(this.contractInput.fromDate);
    let currentInstallment =
      this.dateService.monthDiff(new Date(), fromDate) + 1;
    if (currentInstallment > 12) {
      if (currentInstallment > this.contractInput.installmentQuantity) {
        this.amountOfNewPeriods =
          Math.ceil(this.contractInput.installmentQuantity / 12) - 1;
      } else {
        this.amountOfNewPeriods = Math.ceil(currentInstallment / 12) - 1;
      }
    }
    
    let initialAmount = 0;
  if (this.contractInput.installments && this.contractInput.installments.length > 0) {
    initialAmount = this.contractInput.installments[0].amount;
  } else if (this.contractInput.installmentAmount) {
    initialAmount = this.contractInput.installmentAmount;
  }
    
    const baseAmount = contract.schemaAmount 
                      || contract.secondSchemaAmount 
                      || contract.thirdSchemaAmount 
                      || 0;
    this.invalidSchema = false;
    
    this.contractAmountFormGroup.patchValue({
      schemaAmount: initialAmount, 
      schemeType: this.contractInput.installmentTypeId || 1,
      contractCurrency: this.contractInput.contractCurrency || 1,
      currencyTypeGuaranteeDeposit:
        this.contractInput.initalDepositCurrency || 1,
      guaranteeDepositCurrencyValue: this.contractInput.initialDeposit || null,
      adminAmountCurrencyValue: this.contractInput.fixedFee || null,
      adminAmountPercentageValue: this.contractInput.percentageFee || null,
      adminAmountCurrencyType: this.contractInput.isFixedFee ? 1 : 0,
      paymentExpiryDay: this.contractInput.expirationPayDay || null,
      punitives: this.contractInput.expirationIncrease || null,
      increaseType: this.contractInput.increaseType || null,
    });
    if (this.contractInput.installmentSchemas?.length === 0) {
      this.contractInput.installmentSchemas = [{
        fromDate: this.contractInput.fromDate,
        toDate: this.contractInput.toDate,
        amount: initialAmount || baseAmount, 
        quantity: this.contractInput.installmentQuantity,
        order: 1
      }];
    }
    this.previousFromDate = this.contractInput?.fromDate;
    this.previousToDate = this.contractInput?.toDate;
    if (this.contractInput.installmentTypeId == 1) {
      switch (this.amountOfNewPeriods) {
        case 0:
          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'thirdSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'fifthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'sixthSchemaAmount'
          ].clearValidators();

          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].patchValue(null);
          this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].patchValue(null);
          this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
            null,
          );
          break;
        case 1:
          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'thirdSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'fifthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'sixthSchemaAmount'
          ].clearValidators();

          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].patchValue(this.contractInput.secondSchemaAmount);
          this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].patchValue(null);
          this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
            null,
          );
          break;
        case 2:
          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'thirdSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'fifthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'sixthSchemaAmount'
          ].clearValidators();

          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].patchValue(this.contractInput.secondSchemaAmount);
          this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
            this.contractInput.thirdSchemaAmount,
          );
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].patchValue(null);
          this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
            null,
          );
          break;
      }
      this.contractAmountFormGroup.controls[
        'installmentSchemas'
      ].clearValidators();
      this.contractAmountFormGroup.controls['installmentSchemas'].patchValue(
        null,
      );
      this.contractInput.installmentSchemas = [];
      this.contractAmountFormGroup.controls['schemaAmount'].patchValue(
        this.contractInput.installmentIncreses?.initialAmount || null,
      );
    } else if (this.contractInput.installmentTypeId == 2) {
      this.contractAmountFormGroup.controls['schemaAmount'].clearValidators();
      this.contractAmountFormGroup.controls[
        'secondSchemaAmount'
      ].clearValidators();
      this.contractAmountFormGroup.controls[
        'thirdSchemaAmount'
      ].clearValidators();
      this.contractAmountFormGroup.controls['schemaAmount'].patchValue(null);
      this.contractAmountFormGroup.controls['secondSchemaAmount'].patchValue(
        null,
      );
      this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
        null,
      );
      this.contractInput.installmentIncreses = undefined;
      this.contractAmountFormGroup.controls['installmentSchemas'].patchValue(
        this.contractInput.installmentSchemas || null,
      );
    } else if (this.contractInput.installmentTypeId == 3) {
      if (currentInstallment > 6) {
        if (currentInstallment > this.contractInput.installmentQuantity) {
          this.amountOfNewPeriods =
            Math.ceil(this.contractInput.installmentQuantity / 6) - 1;
        } else {
          this.amountOfNewPeriods = Math.ceil(currentInstallment / 6) - 1;
        }
      }
      switch (this.amountOfNewPeriods) {
        case 0:
          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'thirdSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'fifthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'sixthSchemaAmount'
          ].clearValidators();

          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].patchValue(null);
          this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].patchValue(null);
          this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
            null,
          );
          break;
        case 1:
          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'thirdSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'fifthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'sixthSchemaAmount'
          ].clearValidators();

          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].patchValue(this.contractInput.secondSchemaAmount);
          this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].patchValue(null);
          this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
            null,
          );
          break;
        case 2:
          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'thirdSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'fifthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'sixthSchemaAmount'
          ].clearValidators();

          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].patchValue(this.contractInput.secondSchemaAmount);
          this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
            this.contractInput.thirdSchemaAmount,
          );
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].patchValue(null);
          this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
            null,
          );
          break;
        case 3:
          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'thirdSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'fifthSchemaAmount'
          ].clearValidators();
          this.contractAmountFormGroup.controls[
            'sixthSchemaAmount'
          ].clearValidators();

          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].patchValue(this.contractInput.secondSchemaAmount);
          this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
            this.contractInput.thirdSchemaAmount,
          );
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].patchValue(this.contractInput.fourthSchemaAmount);
          this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
            null,
          );
          this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
            null,
          );
          break;
        case 4:
          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'thirdSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'fifthSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'sixthSchemaAmount'
          ].clearValidators();

          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].patchValue(this.contractInput.secondSchemaAmount);
          this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
            this.contractInput.thirdSchemaAmount,
          );
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].patchValue(this.contractInput.fourthSchemaAmount);
          this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
            this.contractInput.fifthSchemaAmount,
          );
          this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
            null,
          );
          break;
        case 5:
          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'thirdSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'fifthSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);
          this.contractAmountFormGroup.controls[
            'sixthSchemaAmount'
          ].addValidators([
            Validators.min(0),
            Validators.max(2147483647),
            Validators.required,
          ]);

          this.contractAmountFormGroup.controls[
            'secondSchemaAmount'
          ].patchValue(this.contractInput.secondSchemaAmount);
          this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
            this.contractInput.thirdSchemaAmount,
          );
          this.contractAmountFormGroup.controls[
            'fourthSchemaAmount'
          ].patchValue(this.contractInput.fourthSchemaAmount);
          this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
            this.contractInput.fifthSchemaAmount,
          );
          this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
            this.contractInput.sixthSchemaAmount,
          );
          break;
      }

      this.contractAmountFormGroup.controls[
        'installmentSchemas'
      ].clearValidators();
      this.contractAmountFormGroup.controls['installmentSchemas'].patchValue(
        null,
      );
      this.contractInput.installmentSchemas = [];
      this.contractAmountFormGroup.controls['schemaAmount'].patchValue(
        this.contractInput.installmentIncreses?.initialAmount || null,
      );
    }
    
  }

  ngAfterViewInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['contractInput'] && !changes['contractInput'].isFirstChange()) {
      const currentInput = changes['contractInput'].currentValue;
      const previousInput = changes['contractInput'].previousValue;
      if (currentInput?.fromDate !== previousInput?.fromDate || 
          currentInput?.toDate !== previousInput?.toDate) {
        
        this.handleDateChange(currentInput, previousInput);
      }
    }
  }

  handleDateChange(currentInput: any, previousInput: any) {
    this.checkFormData();
    
    if (this.hasFormData) {
      this.dateChangeDetected.emit(true);
    } else {
      this.updateComponentWithNewDates(currentInput);
    }
  }

  checkFormData() {
    const formValues = this.contractAmountFormGroup.value;
    
    this.hasFormData = !!(
      formValues.schemaAmount ||
      formValues.secondSchemaAmount ||
      formValues.thirdSchemaAmount ||
      formValues.fourthSchemaAmount ||
      formValues.fifthSchemaAmount ||
      formValues.sixthSchemaAmount ||
      (this.contractInput?.installmentSchemas && this.contractInput.installmentSchemas.length > 0)
    );
  }

  updateComponentWithNewDates(contractInput: any) {
    this.previousFromDate = contractInput?.fromDate;
    this.previousToDate = contractInput?.toDate;
    this.ngOnInit();
  }

   confirmDateChange() {
    this.hasFormData = false;
    this.updateComponentWithNewDates(this.contractInput);
  }

  cancelDateChange() {
    this.dateChangeDetected.emit(false);
  }

  addNewContractAmount(form) {
    this.edit = false;
    this.editData = null;
    this.modalService.open(form);
  }

  closeModals() {
    this.modalService.dismissAll();
  }

  editElement(form, data, index) {
    this.edit = true;
    this.editData = data;
    this.editData.index = index;
    this.modalService.open(form);
  }

  deleteFrom(ind) {
    this.contractInput.installmentSchemas.splice(ind, 1);
    if (this.contractInput.installmentSchemas.length == 0)
      this.contractInput.installmentSchemas = undefined;
  }

  setElements() {
  var contract = this.contractInput;
  var fromDate = new Date(contract.fromDate);
  
  const preservedAmounts = {
    schemaAmount: this.contractAmountFormGroup.value.schemaAmount,
    secondSchemaAmount: this.contractAmountFormGroup.value.secondSchemaAmount,
    thirdSchemaAmount: this.contractAmountFormGroup.value.thirdSchemaAmount,
    fourthSchemaAmount: this.contractAmountFormGroup.value.fourthSchemaAmount,
    fifthSchemaAmount: this.contractAmountFormGroup.value.fifthSchemaAmount,
    sixthSchemaAmount: this.contractAmountFormGroup.value.sixthSchemaAmount
  };

  const hasPreservedAmounts = Object.values(preservedAmounts).some(amount => amount && amount > 0);
  const preservedInstallmentSchemas = [...(contract.installmentSchemas || [])];

  let currentInstallment = this.dateService.monthDiff(new Date(), fromDate) + 1;
  
  if (
    this.contractAmountFormGroup.value.schemeType == InstallmentTypeEnum.Comercial ||
    this.contractAmountFormGroup.value.schemeType == InstallmentTypeEnum.Vivienda2024
  ) {
    this.contractAmountFormGroup.controls['schemaAmount'].clearValidators();
    this.contractAmountFormGroup.controls['secondSchemaAmount'].clearValidators();
    this.contractAmountFormGroup.controls['thirdSchemaAmount'].clearValidators();
    this.contractAmountFormGroup.controls['fourthSchemaAmount'].clearValidators();
    this.contractAmountFormGroup.controls['fifthSchemaAmount'].clearValidators();
    this.contractAmountFormGroup.controls['sixthSchemaAmount'].clearValidators();

    this.contractAmountFormGroup.controls['schemaAmount'].patchValue(
      preservedAmounts.schemaAmount || null
    );
    this.contractAmountFormGroup.controls['secondSchemaAmount'].patchValue(
      preservedAmounts.secondSchemaAmount || null
    );
    this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
      preservedAmounts.thirdSchemaAmount || null
    );
    this.contractAmountFormGroup.controls['fourthSchemaAmount'].patchValue(
      preservedAmounts.fourthSchemaAmount || null
    );
    this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
      preservedAmounts.fifthSchemaAmount || null
    );
    this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
      preservedAmounts.sixthSchemaAmount || null
    );
    
    if (!contract.installmentIncreses) {
      contract.installmentIncreses = undefined;
    }

    this.contractAmountFormGroup.controls['installmentSchemas'].setValidators([Validators.required]);
    this.contractAmountFormGroup.controls['installmentSchemas'].updateValueAndValidity();

    if (preservedInstallmentSchemas.length > 0) {
      contract.installmentSchemas = this.recalculateInstallmentSchemasDates(
        preservedInstallmentSchemas, 
        contract.fromDate, 
        contract.toDate,
        contract.installmentQuantity
      );
    }

    this.contractAmountFormGroup.controls['installmentSchemas'].patchValue(
      contract.installmentSchemas
    );

  } else {
    if (this.contractAmountFormGroup.value.schemeType == InstallmentTypeEnum.Vivienda2019) {
      if (currentInstallment > 12) {
        if (currentInstallment > contract.installmentQuantity) {
          this.amountOfNewPeriods = Math.ceil(contract.installmentQuantity / 12) - 1;
        } else {
          this.amountOfNewPeriods = Math.ceil(currentInstallment / 12) - 1;
        }
      }
      this.setupViviendaValidators(preservedAmounts);
    } else if (this.contractAmountFormGroup.value.schemeType == InstallmentTypeEnum.Vivienda2023) {
      if (currentInstallment > 6) {
        if (currentInstallment > contract.installmentQuantity) {
          this.amountOfNewPeriods = Math.ceil(contract.installmentQuantity / 6) - 1;
        } else {
          this.amountOfNewPeriods = Math.ceil(currentInstallment / 6) - 1;
        }
      }
      this.setupViviendaValidators(preservedAmounts);
    }

    this.invalidSchema = false;
    this.contractAmountFormGroup.controls['installmentSchemas'].clearValidators();
    this.contractAmountFormGroup.controls['installmentSchemas'].updateValueAndValidity();
    this.contractAmountFormGroup.controls['installmentSchemas'].patchValue(null);
    contract.installmentSchemas = [];

    this.contractAmountFormGroup.controls['schemaAmount'].setValidators([
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]);
    this.contractAmountFormGroup.controls['schemaAmount'].updateValueAndValidity();

    let installmentDinamicToSubmit: InstallmentIncreseForAdd = {
      initialAmount: preservedAmounts.schemaAmount || 0,
      fromDate: contract.fromDate,
      increaseValue: 0,
      increaseTypeId: 1,
      quantity: contract.installmentQuantity,
      contractId: 0,
    };
    contract.installmentIncreses = installmentDinamicToSubmit;
  }

  this.clearPreviousAdminAmount(null);

  contract.installmentTypeId = this.contractAmountFormGroup.value.schemeType;
  contract.contractCurrency = this.contractAmountFormGroup.value.contractCurrency;
  contract.expirationPayDay = this.contractAmountFormGroup.value.paymentExpiryDay;
  contract.expirationIncrease = this.contractAmountFormGroup.value.punitives;
  contract.initalDepositCurrency = this.contractAmountFormGroup.value.currencyTypeGuaranteeDeposit;
  contract.initialDeposit = this.contractAmountFormGroup.value.guaranteeDepositCurrencyValue;
  contract.fixedFee = this.contractAmountFormGroup.value.adminAmountCurrencyValue;
  contract.percentageFee = this.contractAmountFormGroup.value.adminAmountPercentageValue;
  contract.isFixedFee = this.contractAmountFormGroup.value.adminAmountCurrencyType == 1 ? true : false;
  contract.secondSchemaAmount = preservedAmounts.secondSchemaAmount;
  contract.thirdSchemaAmount = preservedAmounts.thirdSchemaAmount;
  contract.fourthSchemaAmount = preservedAmounts.fourthSchemaAmount;
  contract.fifthSchemaAmount = preservedAmounts.fifthSchemaAmount;
  contract.sixthSchemaAmount = preservedAmounts.sixthSchemaAmount;
  contract.increaseType = this.contractAmountFormGroup.value.increaseType;

  this.contractInput = contract;
  this.contractEditService.setContract(contract);

  this.checkAndUpdateValidationState();
}
checkAndUpdateValidationState() {
  const currentValidationState = this.isFormValid();
  
  if (currentValidationState !== this.lastValidationState) {
    this.lastValidationState = currentValidationState;
    
    if (currentValidationState) {
      this.toastService.showToast('success', 'Configuración de montos completada correctamente');
    } else {
      this.toastService.showToast('error', 'Por favor, complete todos los campos requeridos correctamente');
    }
  }
}

onFieldChange() {
  this.setElements();
  setTimeout(() => {
    this.checkAndUpdateValidationState();
  }, 100);
}

private setupViviendaValidators(preservedAmounts: any) {
  switch (this.amountOfNewPeriods) {
    case 0:
      this.clearSecondSchemaAmount();
      this.clearThirdSchemaAmount();
      this.clearFourthSchemaAmount();
      this.clearFifthSchemaAmount();
      this.clearSixthSchemaAmount();
      break;
    case 1:
      this.setSecondSchemaAmountValidator();
      this.contractAmountFormGroup.controls['secondSchemaAmount'].patchValue(
        preservedAmounts.secondSchemaAmount
      );
      this.clearThirdSchemaAmount();
      this.clearFourthSchemaAmount();
      this.clearFifthSchemaAmount();
      this.clearSixthSchemaAmount();
      break;
    case 2:
      this.setSecondSchemaAmountValidator();
      this.setThirdSchemaAmountValidator();
      this.contractAmountFormGroup.controls['secondSchemaAmount'].patchValue(
        preservedAmounts.secondSchemaAmount
      );
      this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
        preservedAmounts.thirdSchemaAmount
      );
      this.clearFourthSchemaAmount();
      this.clearFifthSchemaAmount();
      this.clearSixthSchemaAmount();
      break;
    case 3:
      this.setSecondSchemaAmountValidator();
      this.setThirdSchemaAmountValidator();
      this.setFourthSchemaAmountValidator();
      this.contractAmountFormGroup.controls['secondSchemaAmount'].patchValue(
        preservedAmounts.secondSchemaAmount
      );
      this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
        preservedAmounts.thirdSchemaAmount
      );
      this.contractAmountFormGroup.controls['fourthSchemaAmount'].patchValue(
        preservedAmounts.fourthSchemaAmount
      );
      this.clearFifthSchemaAmount();
      this.clearSixthSchemaAmount();
      break;
    case 4:
      this.setSecondSchemaAmountValidator();
      this.setThirdSchemaAmountValidator();
      this.setFourthSchemaAmountValidator();
      this.setFifthSchemaAmountValidator();
      this.contractAmountFormGroup.controls['secondSchemaAmount'].patchValue(
        preservedAmounts.secondSchemaAmount
      );
      this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
        preservedAmounts.thirdSchemaAmount
      );
      this.contractAmountFormGroup.controls['fourthSchemaAmount'].patchValue(
        preservedAmounts.fourthSchemaAmount
      );
      this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
        preservedAmounts.fifthSchemaAmount
      );
      this.clearSixthSchemaAmount();
      break;
    case 5:
      this.setSecondSchemaAmountValidator();
      this.setThirdSchemaAmountValidator();
      this.setFourthSchemaAmountValidator();
      this.setFifthSchemaAmountValidator();
      this.setSixthSchemaAmountValidator();
      this.contractAmountFormGroup.controls['secondSchemaAmount'].patchValue(
        preservedAmounts.secondSchemaAmount
      );
      this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(
        preservedAmounts.thirdSchemaAmount
      );
      this.contractAmountFormGroup.controls['fourthSchemaAmount'].patchValue(
        preservedAmounts.fourthSchemaAmount
      );
      this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(
        preservedAmounts.fifthSchemaAmount
      );
      this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(
        preservedAmounts.sixthSchemaAmount
      );
      break;
  }
}

private recalculateInstallmentSchemasDates(
  preservedSchemas: any[], 
  newFromDate: Date, 
  newToDate: Date, 
  totalInstallments: number
): any[] {
  if (!preservedSchemas || preservedSchemas.length === 0) {
    return [];
  }

  const startDate = new Date(newFromDate);
  const endDate = new Date(newToDate);
  const totalMonths = this.dateService.monthDiff(endDate, startDate);
  
  return preservedSchemas.map((schema, index) => {
    const monthsPerSchema = Math.ceil(totalMonths / preservedSchemas.length);
    const schemaStartMonth = index * monthsPerSchema;
    const schemaEndMonth = Math.min((index + 1) * monthsPerSchema - 1, totalMonths);
    
    const schemaFromDate = new Date(startDate);
    schemaFromDate.setMonth(schemaFromDate.getMonth() + schemaStartMonth);
    
    const schemaToDate = new Date(startDate);
    schemaToDate.setMonth(schemaToDate.getMonth() + schemaEndMonth);
    
    if (index === preservedSchemas.length - 1) {
      schemaToDate.setTime(endDate.getTime());
    }

    return {
      ...schema,
      fromDate: this.dateService.transformToDateString(schemaFromDate, "-"),
      toDate: this.dateService.transformToDateString(schemaToDate, "-"),
      quantity: Math.ceil(totalInstallments / preservedSchemas.length),
      order: index + 1
    };
  });
}
private debounceTimer: any;
isFormValid(): boolean {
  const schemeType = this.contractAmountFormGroup.value.schemeType;

  
  const relevantErrors = this.getRelevantValidationErrors(schemeType);
  
  
  if (relevantErrors.length > 0) {
    return false;
  }

  if (schemeType == InstallmentTypeEnum.Comercial || 
      schemeType == InstallmentTypeEnum.Vivienda2024) {
    
    const hasSchemas = this.contractInput?.installmentSchemas?.length > 0;
    return hasSchemas;
    
  } else if (schemeType == InstallmentTypeEnum.Vivienda2019 || 
             schemeType == InstallmentTypeEnum.Vivienda2023) {
    
    const isValidPeriods = this.validateViviendaPeriods();
    return isValidPeriods;
  }
  
  return true;
}

private getRelevantValidationErrors(schemeType: number): string[] {
  const errors: string[] = [];
  const formValues = this.contractAmountFormGroup.value;
  const basicRequiredFields = [
    'schemeType',
    'contractCurrency', 
    'currencyTypeGuaranteeDeposit',
    'guaranteeDepositCurrencyValue',
    'paymentExpiryDay',
    'punitives'
  ];
  basicRequiredFields.forEach(fieldName => {
    const control = this.contractAmountFormGroup.get(fieldName);
    if (control && control.errors) {
      errors.push(fieldName);
    }
  });
  if (formValues.adminAmountCurrencyType == 1) {
    const control = this.contractAmountFormGroup.get('adminAmountCurrencyValue');
    if (control && control.errors) {
      errors.push('adminAmountCurrencyValue');
    }
  } else if (formValues.adminAmountCurrencyType == 0) {
    const control = this.contractAmountFormGroup.get('adminAmountPercentageValue');
    if (control && control.errors) {
      errors.push('adminAmountPercentageValue');
    }
  }
  if (schemeType == InstallmentTypeEnum.Vivienda2019 || 
      schemeType == InstallmentTypeEnum.Vivienda2023) {
    const schemaAmountControl = this.contractAmountFormGroup.get('schemaAmount');
    if (schemaAmountControl && schemaAmountControl.errors) {
      errors.push('schemaAmount');
    }
    for (let i = 1; i <= this.amountOfNewPeriods; i++) {
      const fieldName = this.getPeriodFieldName(i + 1);
      const control = this.contractAmountFormGroup.get(fieldName);
      if (control && control.errors) {
        errors.push(fieldName);
      }
    }
  }
  
  
  return errors;
}
private validateViviendaPeriods(): boolean {
  const formValues = this.contractAmountFormGroup.value;
  
  if (!formValues.schemaAmount || formValues.schemaAmount <= 0) {
    return false;
  }

  for (let i = 1; i <= this.amountOfNewPeriods; i++) {
    const fieldName = this.getPeriodFieldName(i + 1);
    const fieldValue = formValues[fieldName];
    
    if (!fieldValue || fieldValue <= 0) {
      return false;
    }
  }

  return true;
}

private getPeriodFieldName(periodNumber: number): string {
  const fieldNames = {
    2: 'secondSchemaAmount',
    3: 'thirdSchemaAmount',
    4: 'fourthSchemaAmount',
    5: 'fifthSchemaAmount',
    6: 'sixthSchemaAmount'
  };
  return fieldNames[periodNumber];
}

getMissingFields(): string[] {
  const missingFields: string[] = [];
  const schemeType = this.contractAmountFormGroup.value.schemeType;
  
  if (schemeType == InstallmentTypeEnum.Comercial || 
      schemeType == InstallmentTypeEnum.Vivienda2024) {
    
    if (!this.contractInput?.installmentSchemas?.length) {
      missingFields.push(' al menos un período de montos fijos, EN EL APARTADO TIPO DE ESQUEMA / MONTOS POR PERIODO');
    }
    
  } else if (schemeType == InstallmentTypeEnum.Vivienda2019 || 
             schemeType == InstallmentTypeEnum.Vivienda2023) {
    
    const formValues = this.contractAmountFormGroup.value;
    
    if (!formValues.schemaAmount || formValues.schemaAmount <= 0) {
      missingFields.push('Valor inicial del primer período');
    }

    for (let i = 1; i <= this.amountOfNewPeriods; i++) {
      const fieldName = this.getPeriodFieldName(i + 1);
      const periodNumber = i + 1;
      
      if (!formValues[fieldName] || formValues[fieldName] <= 0) {
        missingFields.push(`Valor del ${this.getOrdinalText(periodNumber)} período , EN EL APARTADO TIPO DE ESQUEMA / MONTOS POR PERIODO`);
      }
    }
  }

  return missingFields;
}

private getOrdinalText(num: number): string {
  const ordinals = {
    2: 'segundo',
    3: 'tercer',
    4: 'cuarto',
    5: 'quinto',
    6: 'sexto'
  };
  return ordinals[num] || `${num}°`;
}

showValidationErrors(): void {
  const schemeType = this.contractAmountFormGroup.value.schemeType;
  const relevantErrors = this.getRelevantValidationErrors(schemeType);
  const missingFields = this.getMissingFields();
  
  
  if (relevantErrors.length > 0 || missingFields.length > 0) {
    let errorMessage: string;
    
    const allErrors = [...relevantErrors, ...missingFields];
    
    if (allErrors.length === 1) {
      errorMessage = `Debe completar: ${allErrors[0]}`;
    } else {
      const lastError = allErrors.pop();
      errorMessage = `Debe completar: ${allErrors.join(', ')} y ${lastError}`;
    }
    
    this.toastService.showToast('warning', errorMessage);
    this.markInvalidFields();
  }
}

private markInvalidFields(): void {
  const schemeType = this.contractAmountFormGroup.value.schemeType;
  
  if (schemeType == InstallmentTypeEnum.Vivienda2019 || 
      schemeType == InstallmentTypeEnum.Vivienda2023) {
    
    if (!this.contractAmountFormGroup.value.schemaAmount) {
      this.contractAmountFormGroup.controls['schemaAmount'].markAsTouched();
      this.contractAmountFormGroup.controls['schemaAmount'].markAsDirty();
    }

    for (let i = 1; i <= this.amountOfNewPeriods; i++) {
      const fieldName = this.getPeriodFieldName(i + 1);
      const control = this.contractAmountFormGroup.controls[fieldName];
      
      if (control && !control.value) {
        control.markAsTouched();
        control.markAsDirty();
      }
    }
  }
}

canProceedWithEdit(): boolean { 
  if (!this.isFormValid()) {
    this.showValidationErrors();
    return false;
  }
  return true;
}

  setSecondSchemaAmountValidator() {
    this.contractAmountFormGroup.controls['secondSchemaAmount'].setValidators([
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]);
    this.contractAmountFormGroup.controls[
      'secondSchemaAmount'
    ].updateValueAndValidity();
  }

  clearSecondSchemaAmount() {
    this.contractAmountFormGroup.controls[
      'secondSchemaAmount'
    ].clearValidators();
    this.contractAmountFormGroup.controls[
      'secondSchemaAmount'
    ].updateValueAndValidity();
    this.contractAmountFormGroup.controls['secondSchemaAmount'].patchValue(
      null,
    );
  }

  setThirdSchemaAmountValidator() {
    this.contractAmountFormGroup.controls['thirdSchemaAmount'].setValidators([
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]);
    this.contractAmountFormGroup.controls[
      'thirdSchemaAmount'
    ].updateValueAndValidity();
  }

  clearThirdSchemaAmount() {
    this.contractAmountFormGroup.controls[
      'thirdSchemaAmount'
    ].clearValidators();
    this.contractAmountFormGroup.controls[
      'thirdSchemaAmount'
    ].updateValueAndValidity();
    this.contractAmountFormGroup.controls['thirdSchemaAmount'].patchValue(null);
  }

  setFourthSchemaAmountValidator() {
    this.contractAmountFormGroup.controls['fourthSchemaAmount'].setValidators([
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]);
    this.contractAmountFormGroup.controls[
      'fourthSchemaAmount'
    ].updateValueAndValidity();
  }

  clearFourthSchemaAmount() {
    this.contractAmountFormGroup.controls[
      'fourthSchemaAmount'
    ].clearValidators();
    this.contractAmountFormGroup.controls[
      'fourthSchemaAmount'
    ].updateValueAndValidity();
    this.contractAmountFormGroup.controls['fourthSchemaAmount'].patchValue(
      null,
    );
  }

  setFifthSchemaAmountValidator() {
    this.contractAmountFormGroup.controls['fifthSchemaAmount'].setValidators([
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]);
    this.contractAmountFormGroup.controls[
      'fifthSchemaAmount'
    ].updateValueAndValidity();
  }

  clearFifthSchemaAmount() {
    this.contractAmountFormGroup.controls[
      'fifthSchemaAmount'
    ].clearValidators();
    this.contractAmountFormGroup.controls[
      'fifthSchemaAmount'
    ].updateValueAndValidity();
    this.contractAmountFormGroup.controls['fifthSchemaAmount'].patchValue(null);
  }

  setSixthSchemaAmountValidator() {
    this.contractAmountFormGroup.controls['sixthSchemaAmount'].setValidators([
      Validators.min(0),
      Validators.max(2147483647),
      Validators.required,
    ]);
    this.contractAmountFormGroup.controls[
      'sixthSchemaAmount'
    ].updateValueAndValidity();
  }

  clearSixthSchemaAmount() {
    this.contractAmountFormGroup.controls[
      'sixthSchemaAmount'
    ].clearValidators();
    this.contractAmountFormGroup.controls[
      'sixthSchemaAmount'
    ].updateValueAndValidity();
    this.contractAmountFormGroup.controls['sixthSchemaAmount'].patchValue(null);
  }

  clearPreviousInstallmentSchema(schemeType) {
    this.confirmBox
      .toArray()[0]
      .openModal()
      .result.then(
        (result) => {
          if (result) {
            if (schemeType == 1) {
              this.contractInput.installmentSchemas = undefined;
            } else {
              this.contractAmountFormGroup.patchValue({
                schemaAmount: null,
              });
              this.contractInput.installmentIncreses = undefined;
            }
          } else {
          }
        },
        (reason) => {
          //
        },
      );
  }

  clearPreviousAdminAmount(value) {
    if (this.contractAmountFormGroup.value.adminAmountCurrencyType == 1) {
      this.contractAmountFormGroup.patchValue(
        {
          adminAmountPercentageValue: value,
        },
        { onlySelf: true },
      );
    } else {
      this.contractAmountFormGroup.patchValue(
        {
          adminAmountCurrencyValue: value,
        },
        { onlySelf: true },
      );
    }
  }

  showDate(installment) {
    return this.dateService.transformToDateString(new Date(installment), '/');
  }

  validate(field: string) {
    return (
      this.contractAmountFormGroup.controls[field].errors &&
      this.contractAmountFormGroup.controls[field].touched
    );
  }

  isComercialOrVivienda2024(): boolean {
    return (
      this.contractAmountFormGroup.value.schemeType ==
        this.schemeTypeEnum.Comercial ||
      this.contractAmountFormGroup.value.schemeType ==
        this.schemeTypeEnum.Vivienda2024
    );
  }
}
